<template lang="pug">
cabinet-view-content(:caption="_('Telegram chats')")
  cabinet-tabs(
    variant="cabinet-tabs"
    :remain-dom="false"
  )
    vue-tabs-tab(
      :label="_('Unidentified chats')"
      :props="{ icon: 'telegram' }"
    )
      telegram-chats-by-manager(
        :identified="false"
      )

    vue-tabs-tab(
      :label="_('Identified chats')"
      :props="{ icon: 'telegram' }"
    )
      telegram-chats-by-manager(
        :identified="true"
      )
</template>

<script>
import TelegramChatsByManager from '@sections/cabinet/modules/tg-chats/components/TelegramChatsByManager'

export default {
  components: {
    TelegramChatsByManager,
  },
}
</script>